// extracted by mini-css-extract-plugin
export default {"row":"TableRow_row__ZtXsQ","nameCell":"TableRow_nameCell__ymEOw","name":"TableRow_name__qEHF0","photo":"TableRow_photo__XjngL"};